// AJAX submit for every .block-form form. POSTs to /wp-json/jb/v1/form-submit
// which in turn emails the site admin and (optionally) forwards to the
// configured Google Sheets webhook.
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('form[data-jb-form]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const status = form.querySelector('.block-form__status');
      const submit = form.querySelector('.block-form__submit');
      const originalLabel = submit?.textContent ?? 'Send';

      // Validate only on submit: flip the form into its "validated" state so
      // the CSS reveals red borders on missing/invalid required fields, surface
      // the native messages, and focus the first offender — then stop.
      if (!form.checkValidity()) {
        form.classList.add('is-validated');
        const firstInvalid = form.querySelector(':invalid');
        form.reportValidity();
        if (firstInvalid && typeof firstInvalid.focus === 'function') firstInvalid.focus();
        return;
      }

      // Stamp the source page so each submission is attributable to the page
      // it came from (overrides the server-side fallback with the live URL).
      const srcUrl = form.querySelector('input[name="_jb_source_url"]');
      const srcTitle = form.querySelector('input[name="_jb_source_title"]');
      if (srcUrl) srcUrl.value = window.location.href;
      if (srcTitle) srcTitle.value = document.title;

      status?.classList.remove('is-success', 'is-error');
      if (status) status.textContent = '';
      if (submit) {
        submit.disabled = true;
        submit.textContent = 'Sending…';
      }

      const body = Object.fromEntries(new FormData(form).entries());
      const endpoint =
        (window.wpApiSettings && window.wpApiSettings.root
          ? window.wpApiSettings.root
          : '/wp-json/') + 'jb/v1/form-submit';

      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.message || 'Submission failed.');

        if (status) {
          status.textContent = form.dataset.success || data.message || 'Sent.';
          status.classList.add('is-success');
        }

        // Analytics: fire a GA4 event so submissions are tracked per page and
        // per form. Works with gtag.js or GTM (dataLayer); no-ops if neither is
        // present. The page path comes for free in GA, plus explicit params.
        const evtParams = {
          form_name: body._jb_form_name || 'Form',
          page_path: window.location.pathname,
          page_location: window.location.href,
        };
        if (typeof window.gtag === 'function') {
          window.gtag('event', 'form_submit', evtParams);
          window.gtag('event', 'generate_lead', evtParams);
        } else if (Array.isArray(window.dataLayer)) {
          window.dataLayer.push({ event: 'form_submit', ...evtParams });
        }

        form.reset();
      } catch (err) {
        if (status) {
          status.textContent = err.message || 'Something went wrong. Please try again.';
          status.classList.add('is-error');
        }
      } finally {
        if (submit) {
          submit.disabled = false;
          submit.textContent = originalLabel;
        }
      }
    });
  });
});
